import { ResourcesConfig } from 'aws-amplify';

// Configuration updated with new deployed AWS infrastructure
// Values come from environment variables set in .env, .env.local, or .env.production
export const amplifyConfig: ResourcesConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || 'us-west-2_uQWR8mBnL',
      userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID || '33mdkhkfdbabm1li4v2jg7ap3u',
      // identityPoolId not needed for basic authentication
      loginWith: {
        email: true,
        username: false, // Use email as primary login method
      },
      signUpVerificationMethod: 'code', // Email verification required
      userAttributes: {
        email: {
          required: true,
        },
        given_name: {
          required: true,
        },
        family_name: {
          required: true,
        },
      },
      allowGuestAccess: false, // Require authentication for all features
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    },
  },
  // Storage configuration (for future file uploads)
  // Currently not used - placeholder for future functionality
  // Storage: {
  //   S3: {
  //     bucket: import.meta.env.VITE_S3_BUCKET_NAME || 'contentsignal-website-dev-288148419624',
  //     region: import.meta.env.VITE_AWS_REGION || 'us-west-2',
  //   },
  // },
  // API configuration (for future backend integration)
  API: {
    REST: {
      'ContentSignalAPI': {
        endpoint: import.meta.env.VITE_API_ENDPOINT || 'https://api.placeholder.contentsignal.com',
        region: import.meta.env.VITE_AWS_REGION || 'us-west-2',
      },
    },
  },
};